import { textInputColors } from '../constants';
const styleOverrides = {
  root: {
    color: textInputColors.label
  },
  standard: {
    '&.MuiInputLabel-shrink': {
      transform: 'translate(0, -2px) scale(0.86)'
    }
  },
  filled: {
    '&.MuiInputLabel-shrink': {
      transform: 'translate(15px, 0) scale(0.75)'
    }
  },
  outlined: {
    '&.MuiInputLabel-shrink': {
      transform: 'translate(0, 0px) scale(0.86)'
    }
  }
};
const defaultProps = {
  shrink: true
};
export default {
  styleOverrides,
  defaultProps
};